import {action, computed, observable, makeObservable} from 'mobx';

export abstract class Screen {
    @observable selected;
    @observable active;
    @observable isLoading;
    @observable selectedGroup;

    name;
    title;
    entityName;
    hiddenEntityName;
    collection;
    screenChanged;

    constructor(screen, name) {
        makeObservable(this);
        this.name = name;
        this.title = screen.title;
        this.entityName = screen.entityName;
        this.hiddenEntityName = screen.hiddenEntityName;
        this.selectedGroup = [];
        this.screenChanged = false;
    }

    abstract setCollection(data): void;

    setChanged(value) {
        this.screenChanged = value;
    }

    get changed() {
        return this.screenChanged;
    }

    get screen() {
        return this;
    }

    get selectedGroupSorted() {
        return this.selectedGroup.slice().sort(function (a, b) {
            return a.index - b.index;
        });
    }

    get hasPackagesData() {
        return false;
    }

    @computed get loading() {
        return this.isLoading;
    }

    @action
    setLoading(value) {
        this.isLoading = value;
    }

    @action
    setSelected(field) {
        this.selected = field;
    }

    @action
    setActive(field) {
        this.active = field;
    }

    @action
    resetSelected() {
        this.selected = null;
        this.active = null;
    }
}
